<template>
  <v-app id="login">
    <v-snackbar v-model="snackbar" color="error">
      {{ snackbarContent }}
      <v-btn text @click="snackbar = false" timeout="3000">{{$t('close')}}</v-btn>
    </v-snackbar>

    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" class="text-center mb-5">
            <img src="../assets/logo.png" width="200px" />
          </v-col>
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Tableau de bord client</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    :label="$t('email')"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="email"
                    :rules="emailRules"
                  />

                  <v-text-field
                    :label="$t('password')"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  width="100%"
                  color="secondary"
                  @click="login"
                  :loading="loginLoader"
                >{{$t('login')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      emailRules: [
        v => !!v || this.i18n.emailValid,
        v => /.+@.+\..+/.test(v) || this.i18n.emailValid
      ],

      snackbar: false,
      snackbarContent: "",

      loginLoader: false
    };
  },
  created() {
    this.i18n =
      this.$i18n.locale == "fr"
        ? this.$i18n.messages.fr
        : this.$i18n.messages.en;
  },
  methods: {
    //   -------------------------------------------- Login Function ------------------------------------------------------
    login: function() {
      this.loginLoader = true;
      this.$http
        .post("/customer/authenticate", {
          username: this.email,
          password: this.password
        })
        .then(res => {
          let user = res.data.user;
          let token = res.data.token;
          this.$cookies.set("customer_user_token", token, 60 * 60 * 1);

          this.$store.commit("saveUser", { user });

          window.location.href = "/";
        })
        .catch(e => {
          console.log(e.response);
          var err = e.response.status;
          if (err == 401) {
            this.snackbar = true;
            this.snackbarContent = this.i18n.incorrectLogin;

            this.loginLoader = false;
          } else if(err == 404){
            this.snackbar = true;
            this.snackbarContent = this.i18n.noAccountError;

            this.loginLoader = false;
          }else{
            this.snackbar = true;
            this.snackbarContent = this.i18n.loginError;

            this.loginLoader = false;
          }
        });
    }
    // -------------------------------------------- Login function end -----------------------------------------------------
  }
};
</script>